// extracted by mini-css-extract-plugin
export default {"header":"Header_header__2t6Je","navList":"Header_navList__dhkDJ"};